import classNames from 'classnames'

import {
    ChevronDown,
    ChevronUp,
    ChevronSelectorVertical,
    HelpCircle,
} from '@untitled-ui/icons-react'

import { HoverCard } from '@mantine/core'
import ColumnInfoContent from './ColumnInfoContent'

export default function TableHeaderCell({
    label,
    orderBySlug,
    orderBy,
    orderByDirection,
    onClick,
    className,
    tooltip,
    formula,
    width = 'auto',
    ...props
}) {
    const clickable = onClick && orderBySlug

    const classes = classNames(
        'table-cell bg-white/80 backdrop-blur-xs px-5 py-3 border-b select-none',
        { 'hover:bg-gray-50 cursor-pointer': clickable },
        className
    )

    return (
        <div
            {...props}
            className={classes}
            onClick={() => clickable && onClick(orderBySlug)}
            style={{ width: width !== 'auto' ? width + 'px' : null }}
        >
            <div className="flex w-full items-center gap-1 justify-between">
                <div className="flex items-center gap-1.5">
                    <span className="text-ellipsis overflow-hidden whitespace-nowrap text-sm text-gray-900">
                        {label}
                    </span>

                    {tooltip && (
                        <HoverCard position="bottom-start" shadow="md" withinPortal openDelay={100}>
                            <HoverCard.Target>
                                <span
                                    className="inline-flex"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <HelpCircle
                                        className="text-gray-400"
                                        width={15}
                                        height={15}
                                    />
                                </span>
                            </HoverCard.Target>
                            <HoverCard.Dropdown>
                                <ColumnInfoContent
                                    title={label}
                                    tooltip={tooltip}
                                    formula={formula}
                                />
                            </HoverCard.Dropdown>
                        </HoverCard>
                    )}
                </div>

                {clickable &&
                    orderBy === orderBySlug &&
                    orderByDirection === 'asc' && (
                        <ChevronUp width={13} height={13} />
                    )}

                {clickable &&
                    orderBy === orderBySlug &&
                    orderByDirection === 'desc' && (
                        <ChevronDown width={13} height={13} />
                    )}

                {clickable && orderBy !== orderBySlug && (
                    <ChevronSelectorVertical
                        className="text-gray-400"
                        width={13}
                        height={13}
                    />
                )}
            </div>
        </div>
    )
}
